import { MAXIMALIST_FIRST_ORDER_INCENTIVE_240723 } from "@faire/web-api/indigofair/settings/MAXIMALIST_FIRST_ORDER_INCENTIVE_240723";

import { useAssignSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useAssignSettingMaximalistFirstOrderIncentive = () =>
  useAssignSetting(MAXIMALIST_FIRST_ORDER_INCENTIVE_240723);
